import { render, staticRenderFns } from "./LoginSignup.vue?vue&type=template&id=0b269f71"
import script from "./LoginSignup.vue?vue&type=script&lang=js"
export * from "./LoginSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports